import { Components, Theme } from '@mui/material';

export const MuiLink: Components<Theme>['MuiLink'] = {
  defaultProps: {
    color: 'primary',
    underline: 'none',
  },
  styleOverrides: {
    root: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          color: theme.palette.text.link,
          '&:hover': {
            color: theme.palette.text.linkHover,
          },
        };
      }

      return {
        color: theme.palette.secondary.main,
      };
    },
  },
};
